import { compareStrings } from './sorting';

export const sortByTitle = <T>(
  items: readonly T[],
  getTitle: (item: T) => string | undefined,
  locale: string,
) => {
  return items
    .map((item) => ({ item, title: getTitle(item) }))
    .sort((a, b) => {
      if (!a.title || !b.title) {
        return a.title ? -1 : b.title ? 1 : 0;
      }
      return compareStrings(a.title, b.title, true, locale);
    })
    .map(({ item }) => item);
};
